import {
	WidgetInputComplexNumericField,
	WidgetInputSliderField,
	WidgetLabel,
	WidgetSelectDropdown,
	type WidgetSelectDropdownOption,
} from '../../../../rapid-ui'
import type { TextHighlight, TextHighlightStyle } from '../../data/v1'
import { ColorModeInspector } from './color-mode'

const styleOptions: WidgetSelectDropdownOption<TextHighlightStyle>[] = [
	{ id: 'none', label: 'None' },
	{ id: 'marker', label: 'Marker' },
	{ id: 'underline', label: 'Underline' },
	{ id: 'brush', label: 'Brush' },
]

export type TextHighlightInspectorProps = {
	value: TextHighlight
	onChange: (changes: Partial<TextHighlight>, options?: { transient?: boolean }) => void
}

export function TextHighlightInspector({ value, onChange }: TextHighlightInspectorProps) {
	return (
		<div className="flex flex-col gap-2">
			<WidgetLabel label="Highlight">
				<WidgetSelectDropdown
					options={styleOptions}
					value={value.style}
					onChange={(style) => onChange({ style })}
					label="Highlight"
				/>
			</WidgetLabel>

			{value.style !== 'none' && (
				<>
					<ColorModeInspector
						label="Highlight color"
						value={value.color}
						onChange={(color) => onChange({ color })}
					/>

					<WidgetLabel label="Highlight opacity">
						<WidgetInputSliderField
							label="Highlight opacity"
							value={value.opacity}
							onChange={(opacity) => onChange({ opacity })}
							onTransientChange={(opacity) => onChange({ opacity }, { transient: true })}
							min={0}
							max={100}
							suffix="%"
						/>
					</WidgetLabel>

					<div className="grid grid-cols-2 gap-2">
						<WidgetLabel label="Bleed X">
							<WidgetInputComplexNumericField
								value={value.paddingX}
								onChange={(paddingX) => onChange({ paddingX })}
								onTransientChange={(paddingX) => onChange({ paddingX }, { transient: true })}
								min={0}
								defaultValue={10}
								suffix="px"
							/>
						</WidgetLabel>

						<WidgetLabel label="Bleed Y">
							<WidgetInputComplexNumericField
								value={value.paddingY}
								onChange={(paddingY) => onChange({ paddingY })}
								onTransientChange={(paddingY) => onChange({ paddingY }, { transient: true })}
								min={0}
								defaultValue={2}
								suffix="px"
							/>
						</WidgetLabel>
					</div>
				</>
			)}

			{value.style === 'marker' && (
				<WidgetLabel label="Highlight radius">
					<WidgetInputComplexNumericField
						value={value.borderRadius}
						onChange={(borderRadius) => onChange({ borderRadius })}
						onTransientChange={(borderRadius) => onChange({ borderRadius }, { transient: true })}
						min={0}
						defaultValue={0}
						suffix="px"
					/>
				</WidgetLabel>
			)}

			{value.style === 'underline' && (
				<div className="grid grid-cols-2 gap-2">
					<WidgetLabel label="Thickness">
						<WidgetInputComplexNumericField
							value={value.thickness}
							onChange={(thickness) => onChange({ thickness })}
							onTransientChange={(thickness) => onChange({ thickness }, { transient: true })}
							min={1}
							max={100}
							defaultValue={35}
							suffix="%"
						/>
					</WidgetLabel>

					<WidgetLabel label="Raise">
						<WidgetInputComplexNumericField
							value={value.offsetY}
							onChange={(offsetY) => onChange({ offsetY })}
							onTransientChange={(offsetY) => onChange({ offsetY }, { transient: true })}
							defaultValue={0}
							suffix="px"
						/>
					</WidgetLabel>
				</div>
			)}
		</div>
	)
}
